var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.show, "max-width": "900" },
      on: {
        input: function ($event) {
          return _vm.$emit("update:show", $event)
        },
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { attrs: { left: "", color: "primary" } }, [
                _vm._v("mdi-vector-link"),
              ]),
              _vm._v(" Detalhes da junção "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:show", false)
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-card-subtitle", [
            _c("strong", [
              _vm._v(_vm._s(_vm.discipline ? _vm.discipline.name : "")),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "text-center py-4" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  )
                : !_vm.joins.length
                ? _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        text: "",
                        border: "left",
                        dense: "",
                      },
                    },
                    [
                      _vm._v(
                        " Nenhuma junção encontrada para esta disciplina na trilha. "
                      ),
                    ]
                  )
                : _c(
                    "div",
                    _vm._l(_vm.joins, function (join) {
                      return _c(
                        "div",
                        { key: join.join_id, staticClass: "join-block mb-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "join-header d-flex align-center" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: "",
                                    left: "",
                                    color: "primary",
                                  },
                                },
                                [_vm._v("mdi-vector-link")]
                              ),
                              _c("strong", [
                                _vm._v("Junção #" + _vm._s(join.join_id)),
                              ]),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2",
                                  attrs: { "x-small": "", outlined: "" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(join.grids.length) +
                                      " grade(s) "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "mt-2 join-table",
                              attrs: { dense: "" },
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Turma")]),
                                  _c("th", [_vm._v("Disciplina")]),
                                  _c("th", [_vm._v("Período")]),
                                  _c("th", [_vm._v("Grade")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(join.grids, function (g) {
                                  return _c(
                                    "tr",
                                    {
                                      key: g.grid_id,
                                      class: { "is-main": g.is_main },
                                    },
                                    [
                                      _c("td", [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(g.group ? g.group.name : "—")
                                          ),
                                        ]),
                                        g.group && g.group.code
                                          ? _c(
                                              "small",
                                              { staticClass: "grey--text" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(g.group.code) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c("td", [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              g.discipline
                                                ? g.discipline.name
                                                : "—"
                                            )
                                          ),
                                        ]),
                                        g.discipline && g.discipline.code
                                          ? _c(
                                              "small",
                                              { staticClass: "grey--text" },
                                              [
                                                _vm._v(
                                                  " [" +
                                                    _vm._s(g.discipline.code) +
                                                    "] "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              g.work_time
                                                ? g.work_time.name
                                                : "—"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("td", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                            staticStyle: { gap: "4px" },
                                          },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  label: "",
                                                  outlined: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      g.grid_code || g.grid_id
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            g.is_main
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                        color:
                                                                          "warning",
                                                                      },
                                                                    },
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " mdi-star "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Grade principal da junção"
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:show", false)
                    },
                  },
                },
                [_vm._v("Fechar")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }